<template>
  <!-- Navbar -->
  <nav
    class="main-header navbar navbar-expand navbar-light border-bottom"
    style="background-color: #FFFFFF"
  >
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <!--
      <li class="nav-item">
        <a
          class="nav-link"
          data-widget="pushmenu"
          @click="openNav"
        >
          <i class="fa fa-bars" />
        </a>
      </li>
      -->
      <li>
        <a
          class="nav-link"
          data-toggle="dropdown"
          title="Home"
          @click="toHome"
        >
          <h4 class="tag">Online Shop - Admin Panel</h4>
          <!-- <h4 class="orange tag">ACH Online Shop - Admin</h4> -->
        </a>
      </li>
    </ul>
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Messages Dropdown Menu -->
      <!--
      <li
        v-if="user_id != '9'"
        class="nav-item dropdown"
      >
        <a
          class="nav-link"
          data-toggle="dropdown"
          to="/Sample1"
        >
          <i class="fa fa-user white" />
        </a>
      </li>
      <li
        v-if="user_id != '9'"
        class="nav-item dropdown"
      >
        <a
          class="nav-link tag"
          data-toggle="dropdown"
          title="Shopping Cart"
          @click="toShoppingCart"
        >
          <i
            class="fa fa-shopping-cart white fa-2x"
            aria-hidden="true"
          />
        </a>
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          data-toggle="dropdown"
          title="Login as admin"
          @click="toLogin"
        >
          <i
            class="fa fa-sign-in"
            aria-hidden="true"
          />
        </a>
      </li>
      -->
      <li class="nav-item dropdown">
        <a
          class="nav-link"
          data-toggle="dropdown"
          to="/Sample1"
        >
          <i class="fa fa-user-circle-o">{{ ' ' + username }}</i>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link tag"
          data-toggle="dropdown"
          @click="logout"
        >
          <i class="fa fa-sign-out" />

          <!-- Message End -->
        </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      username: localStorage.getItem('fs_user'),
      user_id: localStorage.getItem('fs_user_id'),
      fs_username: localStorage.getItem('fs_username')
    }
  },
  computed: {
  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout')
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    },
    openNav () {
      var sidebar = document.getElementById('sidebar')
      if (sidebar.classList.contains('sidebar-collapse')) {
        sidebar.classList.replace('sidebar-collapse', 'sidebar-open')
      } else {
        sidebar.classList.replace('sidebar-open', 'sidebar-collapse')
      }
    },
    toHome () {
      if (this.$route.name !== 'Home') this.$router.push({ name: 'Home' })
      else this.$router.go()
    },
    toLogin () {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.tag {
  cursor: pointer;
}
.white {
  color: white;
}
.orange {
  color: orange;
}
</style>
